import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseServiceWithInterceptor } from "../base-service";
import { User } from "../users-api/types";
import {
  ChangePasswordRequest,
  LoginResponse,
  SetPasswordRequest,
  SignUpRequest,
  VerifyPasswordTokenRequest,
} from "./types";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: createBaseServiceWithInterceptor(process.env.REACT_APP_API_URL),
  endpoints: (builder) => ({
    getUser: builder.query<User, Record<string, unknown>>({
      query: () => ({ url: `users/me` }),
    }),
    exchangeToken: builder.mutation<LoginResponse, string>({
      query: (token) => ({
        url: "exchange-token",
        method: "POST",
        headers: {
          idtoken: token,
        },
      }),
    }),
    setPassword: builder.mutation<any, SetPasswordRequest>({
      query: (credentials) => ({
        url: "set-password",
        method: "PUT",
        body: credentials,
      }),
    }),
    forgotPassword: builder.mutation<any, SignUpRequest>({
      query: (credentials) => ({
        url: "forgot-password",
        method: "POST",
        body: credentials,
      }),
    }),
    changePassword: builder.mutation<any, ChangePasswordRequest>({
      query: (credentials) => ({
        url: "change-password",
        method: "POST",
        body: credentials,
      }),
    }),
    verifyPasswordToken: builder.mutation<any, VerifyPasswordTokenRequest>({
      query: (credentials) => ({
        url: "verify-password-token",
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

export const {
  useGetUserQuery,
  useExchangeTokenMutation,
  useSetPasswordMutation,
  useForgotPasswordMutation,
  useChangePasswordMutation,
  useVerifyPasswordTokenMutation,
} = authApi;
